// extracted by mini-css-extract-plugin
export default {"flex":"foot_flex__GG3fC","flex2":"foot_flex2__SLoyl","link":"foot_link__bN6X6","contents":"foot_contents__GFXU8","contens":"foot_contens__sIAqm","cright":"foot_cright__FuzRW"};